module.exports = __webpack_public_path__ + "img/compare.5bdfb43d.svg";